import script from "./ReportStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportStatCard.vue?vue&type=script&setup=true&lang=js"

import "./ReportStatCard.vue?vue&type=style&index=0&id=054deca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054deca2"]])

export default __exports__